import styled from 'styled-components';

export interface IChipProps extends React.PropsWithChildren {
  type?: 'primary' | 'secondary' | 'warning' | 'error' | 'black' | 'success';
}

const typeStyles: Record<NonNullable<IChipProps['type']>, { bg: string; color: string }> = {
  primary: { bg: '#E3F2FD', color: '#1976D2' }, // Blue
  secondary: { bg: '#F3E5F5', color: '#7B1FA2' }, // Purple
  success: { bg: '#E8F5E9', color: '#2E7D32' }, // Green
  warning: { bg: '#FFF8E1', color: '#F57C00' }, // Orange
  error: { bg: '#FFEBEE', color: '#D32F2F' }, // Red
  black: { bg: '#E0E0E0', color: '#212121' }, // Black/Grey
};

const StyledChip = styled.div<{ $type?: IChipProps['type'] }>`
  background-color: ${({ $type }) => ($type ? typeStyles[$type].bg : '#E8F5E9')};
  color: ${({ $type }) => ($type ? typeStyles[$type].color : '#4CAF50')};
  font-weight: 500;
  font-size: 0.8em;
  padding: 0.25em 0.5em;
  border-radius: 0.5em;
  width: fit-content;
`;

export const Chip = ({ type = 'primary', children }: IChipProps) => {
  return (
    <StyledChip $type={type}>
      <span>{children}</span>
    </StyledChip>
  );
};